import request from '@/utils/request'
import requestNoMessage from '@/utils/request-no-message'

/**
 * @description 获取订单总数
 */
function orderTotal(params) {
  return requestNoMessage({
    url: '/ajax_order_total',
    method: 'get',
    params
  })
}

/**
 * @description 提交订单--预付款
 */
function submitOrder(data) {
  return request({
    url: '/api/ajax_pre_charge',
    method: 'post',
    data
  })
}

/**
 * @description 获取订单列表--预付款
 */
function getOrderList(params) {
  return request({
    url: '/ajax_pre_charge_list',
    method: 'get',
    params
  })
}

/**
 * @description 预付款支付凭证-预付款
 */
function submitPayImg(data) {
  return request({
    url: '/api/ajax_pre_charge_pay_img',
    method: 'post',
    data
  })
}

/**
 * @description 上传押金凭证-预付款押金被驳回时重新提交
 */
function submitDepositVoucher(data) {
  return request({
    url: '/api/ajax_pre_charge_deposit_img',
    method: 'post',
    data
  })
}

/**
 * @description 预存金额明细
 */
function rechargeList(params) {
  return request({
    url: '/ajax_pre_charge_log_list',
    method: 'get',
    params
  })
}

export {
  orderTotal,
  submitOrder,
  getOrderList,
  submitPayImg,
  submitDepositVoucher,
  rechargeList
}